export const refundedStatus = [
  { value: 'true', label: 'Estornadas' },
  { value: 'false', label: 'Não estornadas' },
]
